// import React, { Component } from "react";

// // ============ Miscellaneous Files ============
// import ResultRow from "./result-row";
// import "../stylesheets/results.css";

// // ============ MDB Components ============
// import { MDBContainer, MDBTable, MDBTableBody, MDBTableHead } from "mdb-react-ui-kit";

// class Results extends Component {
//    render() {
//       const props = this.props;
//       let resultJobCards = props.resultJobCards, jobCardSerialNo = 0, jobCardWarranty, partsList, i, len;
//       let selectedTOS = props.typeOfService, startDate = props.startDate, endDate = props.endDate, selectedReports = 0;

//       return (
//          <MDBContainer>
//             <MDBTable className="result-table" responsive bordered borderColor="primary" align="middle">
//                <MDBTableHead dark>
//                   <tr>
//                      <th>Sl. No.</th>
//                      <th>Job Card No.</th>
//                      <th>Machine No.</th>
//                      <th>Vehicle No.</th>
//                      {(selectedTOS === "all" || selectedTOS === "") && <th>Type of Service</th>}
//                      <th>Warranty</th>
//                      <th>Edit</th>
//                      <th>Alter Warranty</th>
//                   </tr>
//                </MDBTableHead>

//                <MDBTableBody>
//                   {
//                      Object.keys(resultJobCards).length !== 0 &&
//                      resultJobCards.map((value, key) => {
//                         partsList = value["part-info-list"];
//                         len = partsList.length;
//                         jobCardWarranty = "No";
//                         for (i = 0; i < len; i++) {
//                            if (partsList[i].warranty === "Yes") {
//                               jobCardWarranty = "Yes";
//                               break;
//                            }
//                         }

//                         const dateOfInstallaion = new Date(new Date(new Date(value["date-of-inst"]).toISOString().split("T")[0]).getTime() + 24 * 60 * 60 * 1000).toISOString().split("T")[0];
//                         if (new Date(startDate).toISOString().split("T")[0] <= dateOfInstallaion && dateOfInstallaion <= new Date(endDate).toISOString().split("T")[0]) {
//                            selectedReports++;
//                            return (
//                               <ResultRow key={key} value={value} keys={key} jobCardSerialNo={selectedReports}
//                                  warranty={jobCardWarranty} selectedTOS={selectedTOS} />
//                            );
//                         }
//                      })
//                   }

//                   {
//                      (resultJobCards === {} || selectedReports === 0) &&
//                      <tr>
//                         <td colSpan={"100%"}>No Job Cards found for the applied Filters</td>
//                      </tr>
//                   }
//                </MDBTableBody>
//             </MDBTable>
//          </MDBContainer>
//       );
//    }
// }

// export default Results;


import React, { Component } from "react";

// ============ Miscellaneous Files ============
import ResultRow from "./result-row";
import { MDBContainer, MDBTable, MDBTableBody, MDBTableHead } from "mdb-react-ui-kit";

class Results extends Component {
   render() {
      const props = this.props;
      let results = props.results, warranty, partInfoList, i, len;
      let selectedTOS = props.typeOfService, selectedReports = 0;

      return (
         <MDBContainer>
            <MDBTable responsive bordered style={{ "textAlign": "center", "verticalAlign": "center" }}>
               <MDBTableHead dark>
                  <tr>
                     <th>Job Card No.</th>
                     <th>Created Date</th>
                     <th>Machine No.</th>
                     <th>Vehicle No.</th>
                     <th>Job Card</th>
                     <th>Warranty</th>
                  </tr>
               </MDBTableHead>

               <MDBTableBody>
                  {
                     (results != undefined && Object.keys(results).length !== 0) &&
                     results.map((value, key) => {
                        partInfoList = value["part-info-list"];
                        len = partInfoList.length;
                        warranty = "No";
                        for (i = 0; i < len; i++) {
                           if (partInfoList[i].warranty === "Yes") {
                              warranty = "Yes";
                              break;
                           }
                        }

                        selectedReports++;
                        return (
                           <ResultRow key={key} value={value} keys={key} warranty={warranty} selectedTOS={selectedTOS} />
                        );
                     })
                  }

                  {
                     (results === {} || selectedReports === 0) &&
                     <tr>
                        <td colSpan={"100%"}>No Job Cards found</td>
                     </tr>
                  }
               </MDBTableBody>
            </MDBTable>
         </MDBContainer>
      );
   }
}

export default Results;
